<template>
  <div class="component-bottom-float">
    <slot></slot>
  </div>
</template>
<style lang="scss">
  .component-bottom-float{
    position: fixed;
    width: calc(100% - 215px);
    height: 40px;
    left: 205px;
    bottom: 0;
    background: #eee;
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/bottomFloat/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/bottomFloat/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/bottomFloat/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-bottomFloat')
  export default {
    name: 'base-bottomFloat', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-bottomFloat': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>